import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog'
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core'
import { Router } from '@angular/router'

import { Badge } from '@features/sala-de-trofeos/models'
import { Image } from '@shared/components'

interface Data {
  badge: Badge
}

@Component({
  selector: 'badge-details-modal',
  imports: [Image],
  templateUrl: './badge-details-modal.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BadgeDetailsModal {
  dialogRef = inject(DialogRef)
  #router = inject(Router)
  data: Data = inject(DIALOG_DATA)

  background = computed(() => {
    const colors = this.data.badge.colors
    if (colors.length > 1) return `linear-gradient(180deg, ${colors.join(', ')})`
    return colors[0] ?? ''
  })

  goToTiroLibre() {
    this.#router.navigate(['/tiros-libres', this.data.badge.tiroLibre])
    this.dialogRef.close()
  }
}
